export default "__VITE_ASSET__B$c6sKBv__"